import React from "react";
import ProductOrOptionComponent from "../../components/ProductOrOptionComponent";


export default function Options() {

    return (
        <ProductOrOptionComponent type='options' title='Options'/>
    );
}